import { BrowserRouter, Switch } from "react-router-dom";
import LandingPage from "../pages/public/LandingPage";
import DashBoard from "../pages/private/DashBoard.jsx";
import PrivateRoute from "./PrivateRoute";
import PublicRoutes from "./PublicRoutes";
import { auth } from "../database/firebase";
import SignUp from "../pages/public/SignUp";
import Signin from "../pages/public/Signin";
import { useEffect, useState } from "react";

import { onAuthStateChanged } from "firebase/auth";

const AppRouter = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path="/home" component={DashBoard} authState={user} />
        <PublicRoutes path="/sign-up" component={SignUp} authUser={user} />
        <PublicRoutes path="/sign-in" component={Signin} authUser={user} />
        <PublicRoutes exact path="/" component={LandingPage} authUser={user} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
